import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkComponent = styled(Link)`
	text-decoration: none;
`
